// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + (chunkId === 537 ? "support" : chunkId) + "-" + {242: "1bdcd3cb592083f5",537: "81e5b14e806061f1",}[chunkId] + ".chunk.js"
}